import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';
import { ServiceType, Supplier } from '../models';

@Pipe({
	name: 'compensationFilter',
	standalone: false,
})
export class CompensationFilterPipe implements PipeTransform {
	transform(compensations: any[], suppliers: Supplier[], serviceTypes: ServiceType[], hasUpfront: boolean): any[] {
		return compensations
			? compensations.filter(
					c =>
						(!suppliers.length || suppliers.some(s => s.supplierId === c.supplierId)) &&
						(!serviceTypes.length ||
							(serviceTypes.some(st => st.serviceTypeId === CONSTANTS.serviceTypes.electricity.serviceTypeId) &&
								(c.upfront.hasElec || c.upfront50.hasElec || c.residual.hasElec)) ||
							(serviceTypes.some(st => st.serviceTypeId === CONSTANTS.serviceTypes.naturalGas.serviceTypeId) &&
								(c.upfront.hasGas || c.upfront50.hasGas || c.residual.hasGas))) &&
						(!hasUpfront || c.upfront.rules?.length || c.upfront50.rules?.length),
				)
			: compensations;
	}
}
